module.exports={render:function (){var _vm=this;
  return _vm._c('div', [_vm._c('router-view'), _vm._v(" "), _vm._v(" "), _vm._c('movie', {
    attrs: {
      "filter": this.filterTags,
      "handleUpdateFilterTag": _vm.updateFilterTag,
      "preLoadingImage": this.preLoadingImage
    }
  }), _vm._v(" "), _vm._v(" "), _vm._c('div', {
    staticClass: "main-content"
  }, [_vm._c('clip-loader', {
    attrs: {
      "loading": _vm.isLoading,
      "color": _vm.color
    }
  }), _vm._v(" "), _vm._v(" "), _vm._c('div', {
    class: ['main-title', {
      'main-title-menu-is-open': this.$parent.isDisplayed
    }]
  }, [_vm._c('h2', [_vm._v("Well... the television said that's the right thing to do.")]), _vm._v(" "), _vm._c('span', [_vm._v("Tom, Night of the living dead")])]), _vm._v(" "), _vm._v(" "), (_vm.onTop[0] && (_vm.onTop[0].backdrops || _vm.onTop[0].poster)) ? _vm._c('router-link', {
    class: ['on-top', {
      'on-search': _vm.filterKey || _vm.filterTags
    }],
    style: ({
      backgroundImage: 'url(https://image.tmdb.org/t/p/w1280' + _vm.onTop[0].backdrops[0] + ')'
    }),
    attrs: {
      "to": {
        name: 'movie',
        params: {
          slug: _vm.onTop[0].slug
        }
      }
    }
  }, [_vm._c('div', [_vm._c('div', {
    staticClass: "bloc-title"
  }, [_vm._c('h2', [_vm._v(_vm._s(_vm.onTop[0].title_tmdb))]), _vm._v(" "), _vm._c('h3', [(_vm.onTop[0].director) ? _vm._c('span', [_vm._v(_vm._s(_vm.onTop[0].director[0]) + ", ")]) : _vm._e(), _vm._v(_vm._s(_vm.onTop[0].date))])]), _vm._v(" "), _vm._c('div', {
    staticClass: "bloc-overview"
  }, [(_vm.onTop[0].overview) ? _vm._c('span', [_vm._v(_vm._s(_vm.onTop[0].overview))]) : _vm._e(), _vm._v(" "), (!_vm.onTop[0].overview && _vm.onTop[0].tagline) ? _vm._c('span', [_vm._v(_vm._s(_vm.onTop[0].overview.substring(0, 65) + '...'))]) : _vm._e(), _vm._v(" "), _vm._c('span', {
    staticClass: "duration"
  }, [_vm._v(_vm._s(_vm.onTop[0].duration) + " minutes")])])])]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._c('div', {
    staticClass: "movies"
  }, [_vm._c('transition-group', {
    attrs: {
      "name": "populate",
      "tag": "div"
    }
  }, _vm._l((_vm.filteredMovies), function(movie, i) {
    return _vm._c('div', {
      key: i,
      staticClass: "movie",
      on: {
        "click": function($event) {
          _vm.handleSelectMovie(movie)
        }
      }
    }, [(movie && (movie.backdrops || movie.poster)) ? _vm._c('router-link', {
      attrs: {
        "to": {
          name: 'movie',
          params: {
            slug: movie.slug
          }
        }
      }
    }, [_vm._c('div', {
      staticClass: "movie-image",
      style: ({
        backgroundImage: 'url(https://image.tmdb.org/t/p/w780' + (movie.backdrops ? movie.backdrops[0] : movie.poster) + ')'
      })
    }, [(_vm.selectedMovie && _vm.selectedMovie.id_tmdb === movie.id_tmdb) ? _vm._c('div', {
      staticClass: "movie-picto-is-playing"
    }, [_vm._c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 58 58"
      },
      attrs: {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 58 58",
        "xml:space": "preserve"
      }
    }, [_vm._c('circle', {
      staticStyle: {
        "fill": "rgba(44, 62, 80, 0.9)"
      },
      attrs: {
        "cx": "29",
        "cy": "29",
        "r": "29"
      }
    }), _vm._v(" "), _vm._c('polygon', {
      staticStyle: {
        "fill": "rgb(255, 255, 255, 0.9)"
      },
      attrs: {
        "points": "44,29 22,44 22,29.273 22,14  "
      }
    })])]) : _vm._e(), _vm._v(" "), _vm._c('div', {
      staticClass: "movie-infos"
    }, [_vm._c('h2', [(movie.slug) ? _vm._c('div', [_vm._v("\n                      " + _vm._s(movie.title_tmdb) + "\n                    ")]) : _vm._c('div', [_vm._c('span', [_vm._v(_vm._s(movie.title_tmdb))])]), _vm._v(" ")]), _vm._v(" "), _vm._c('h3', [(movie.director) ? _vm._c('span', [_vm._v(_vm._s(movie.director[0]) + ", ")]) : _vm._e(), _vm._v(_vm._s(movie.date))]), _vm._v(" "), _vm._c('p', {
      staticClass: "synopsis"
    }, [(movie.tagline) ? _vm._c('span', [_vm._v(_vm._s(movie.tagline))]) : _vm._e(), _vm._v(" "), (!movie.tagline && movie.overview) ? _vm._c('span', [_vm._v(_vm._s(movie.overview.substring(0, 65) + '...'))]) : _vm._e(), _vm._v(" "), _vm._c('span', {
      staticClass: "duration"
    }, [_vm._v(_vm._s(movie.duration) + " minutes")])])])])]) : _vm._e(), _vm._v(" "), (_vm.isDisplayed) ? _vm._c('div', {
      staticClass: "movie-backdrops-admin",
      style: ({
        background: (movie.backdrops ? 'url(https://image.tmdb.org/t/p/w300' + movie.backdrops[0] : 'blue') + ')'
      })
    }, [_vm._c('span', [_vm._v(_vm._s(movie.backdrops ? movie.backdrops.length : '0'))]), _vm._v(" "), _vm._l((movie.backdrops), function(backdrop, iBackdrop) {
      return _vm._c('img', {
        attrs: {
          "src": 'https://image.tmdb.org/t/p/w300' + backdrop,
          "alt": ""
        },
        on: {
          "click": function($event) {
            _vm.selectImage(movie['.key'], movie.backdrops, backdrop, iBackdrop)
          }
        }
      })
    })], true) : _vm._e()])
  }))]), _vm._v(" "), _vm._c('div', {
    class: ['no-results', {
      active: _vm.hasNoSearchResults
    }]
  }, [_vm._v("No results.")]), _vm._v(" "), _vm._v(" "), _vm._v(" ")]), _vm._v(" "), _vm._v(" "), (this.$route.name === 'admin') ? _vm._c('div', {
    staticClass: "movies-ui-infos"
  }, [_vm._v("\n  INFOS :\n  "), _vm._c('br'), _vm._v("\n    searchQuery : " + _vm._s(_vm.filterKey) + "\n  "), _vm._c('br'), _vm._v("\n    Sort By : " + _vm._s(_vm.sortKey) + "\n  "), _vm._c('br'), _vm._v("\n    Genre Selected : " + _vm._s(_vm.filterTags) + "\n  "), _vm._c('br'), _vm._v("\n    Movies Displayed : " + _vm._s(_vm.loadedMoviesCount) + "\n  "), _vm._c('br'), _vm._v(" "), _vm._c('span', {
    on: {
      "click": function($event) {
        _vm.toggleContent()
      }
    }
  }, [_vm._v("-! Admin backdrops !-")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-83b5eaf0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Movies.vue
// module id = 352
// module chunks = 2